import { render, staticRenderFns } from "./LoadBoard.vue?vue&type=template&id=4a34a127"
import script from "./LoadBoard.vue?vue&type=script&lang=js"
export * from "./LoadBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports